<div class="wrapper">
  @for (item of snackItems; track trackSnack($index, item)) {
    <app-snack [data]="item" (clear)="onClear(item)"></app-snack>
  }
</div>
